<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><b>PART I</b></p>
<p class="part1"><i>O<span class="small">UT</span> <span class="small">OF THE</span> P<span class="small">AST</span></i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?0d4596db